import type { ReactNode } from 'react';
import React from 'react';
import { noop } from 'src/components/base';

import * as S from './styles';

type Props = {
  link?: string;
  name: string;
  image?: ReactNode;
  callToActionText?: string;
  showArrow?: boolean;
  showBackArrow?: boolean;
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
  isExternal?: boolean;
  linkAttributes?: {
    target?: string;
    rel?: string;
  };
  'data-test'?: string;
  disabled?: boolean;
};

export const ListItem = ({
  children,
  name,
  link,
  image,
  callToActionText,
  showArrow,
  showBackArrow,
  onClick = noop,
  className,
  isExternal,
  linkAttributes,
  'data-test': dataTest,
  disabled,
}: Props) => (
  <S.ListItem
    onClick={onClick}
    className={className}
    to={link}
    isExternal={isExternal}
    {...(linkAttributes || {})}
    data-test={dataTest}
    disabled={disabled}
  >
    {showBackArrow && <S.LeftArrow />}
    {image && <S.Image>{image}</S.Image>}
    {children}
    <S.Name>{name}</S.Name>
    {callToActionText && <S.CallToAction>{callToActionText}</S.CallToAction>}
    {showArrow && <S.RightArrow />}
  </S.ListItem>
);
